export default "__VITE_ASSET__BasDhy_M__"